import React from 'react';
import { Card, CardContent } from '@mui/material';
import { MovableFrame } from 'components/views/atoms/MovableFrame';
import { WallClock } from 'components/views/molecules/WallClock';

export type WallClockProps = {
    top?: number;
    left?: number;
    width?: number | string;
    height?: number | string;
}

export function WallClockWidget(props: WallClockProps) {
    const { top, left, width, height } = props;

    return (
        <MovableFrame title="Current Time" top={top} left={left} width={width} height={height} resizable={false}>
            <Card>
                <CardContent>
                    <WallClock />
                </CardContent>
            </Card>
        </MovableFrame>
    );
}
